const textFieldFormServiceQuesList = {
  comment: 'Comment',
  
};

export default textFieldFormServiceQuesList;
